import { render } from "./pp.vue?vue&type=template&id=13a3b50f&scoped=true"
import script from "./pp.vue?vue&type=script&lang=js"
export * from "./pp.vue?vue&type=script&lang=js"

import "./pp.vue?vue&type=style&index=0&id=13a3b50f&scoped=true&lang=sass"
import "./pp.vue?vue&type=style&index=1&id=13a3b50f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a3b50f"]])

export default __exports__